/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AcceptedFreelancerUmbrellaInvitationResource } from './';
import {
    AcceptedFreelancerUmbrellaInvitationResourceFromJSON,
    AcceptedFreelancerUmbrellaInvitationResourceFromJSONTyped,
    AcceptedFreelancerUmbrellaInvitationResourceToJSON,
} from './';
import type { PendingFreelancerUmbrellaInvitationResource } from './';
import {
    PendingFreelancerUmbrellaInvitationResourceFromJSON,
    PendingFreelancerUmbrellaInvitationResourceFromJSONTyped,
    PendingFreelancerUmbrellaInvitationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerUmbrellaInvitationsResource
 */
export interface FreelancerUmbrellaInvitationsResource {
    /**
     * 
     * @type {Array<AcceptedFreelancerUmbrellaInvitationResource>}
     * @memberof FreelancerUmbrellaInvitationsResource
     */
    acceptedInvitations: Array<AcceptedFreelancerUmbrellaInvitationResource>;
    /**
     * 
     * @type {Array<PendingFreelancerUmbrellaInvitationResource>}
     * @memberof FreelancerUmbrellaInvitationsResource
     */
    pendingInvitations: Array<PendingFreelancerUmbrellaInvitationResource>;
}

/**
 * Check if a given object implements the FreelancerUmbrellaInvitationsResource interface.
 */
export function instanceOfFreelancerUmbrellaInvitationsResource(value: object): value is FreelancerUmbrellaInvitationsResource {
    if (!('acceptedInvitations' in value) || value['acceptedInvitations'] === undefined) return false;
    if (!('pendingInvitations' in value) || value['pendingInvitations'] === undefined) return false;
    return true;
}

export function FreelancerUmbrellaInvitationsResourceFromJSON(json: any): FreelancerUmbrellaInvitationsResource {
    return FreelancerUmbrellaInvitationsResourceFromJSONTyped(json, false);
}

export function FreelancerUmbrellaInvitationsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerUmbrellaInvitationsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'acceptedInvitations': ((json['acceptedInvitations'] as Array<any>).map(AcceptedFreelancerUmbrellaInvitationResourceFromJSON)),
        'pendingInvitations': ((json['pendingInvitations'] as Array<any>).map(PendingFreelancerUmbrellaInvitationResourceFromJSON)),
    };
}

export function FreelancerUmbrellaInvitationsResourceToJSON(value?: FreelancerUmbrellaInvitationsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'acceptedInvitations': ((value['acceptedInvitations'] as Array<any>).map((v) => AcceptedFreelancerUmbrellaInvitationResourceToJSON(v))),
        'pendingInvitations': ((value['pendingInvitations'] as Array<any>).map((v) => PendingFreelancerUmbrellaInvitationResourceToJSON(v))),
    };
}

